import React, { useEffect, useState } from "react";
import Login from "./login.js";
export default function LoginManager(props) {
    const [loginBox, setLoginBox] = useState(null);
    useEffect(() => {
        props.setFunction((props) => {
            setLoginBox(React.createElement(Login, { ...props, onExit: () => {
                    setLoginBox("");
                } }));
        });
    }, [props.setFunction]);
    return React.createElement("div", null, loginBox);
}
